import { render, staticRenderFns } from "./Trash2.vue?vue&type=template&id=bcb60762"
import script from "./Trash2.vue?vue&type=script&lang=js"
export * from "./Trash2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports